// SPDX-License-Identifier: Apache-2.0
import { Config as SanitizeConfig } from 'dompurify';

export const defaultNewsSanitizeConfig = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed'],
  FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick']
} as SanitizeConfig;

export const defaultPermalinkSanitizeConfig = {
  ALLOWED_TAGS: ['br', 'b', 'div', 'em', 'i', 'p', 'strong'],
  ALLOWED_ATTR: []
} as SanitizeConfig;

export const defaultQuerySanitizeConfig = {
  ALLOWED_TAGS: ['iframe', 'a', 'img'],
  ADD_ATTR: ['target']
} as SanitizeConfig;
